import { defineComponent, openBlock, createElementBlock, createElementVNode } from 'vue';
import _export_sfc from './_virtual/plugin-vue_export-helper.mjs';

const _sfc_main = defineComponent({
  name: "XlBiaoge"
});
const _hoisted_1 = {
  t: "1664508570855",
  class: "icon",
  viewBox: "0 0 1152 1024",
  version: "1.1",
  xmlns: "http://www.w3.org/2000/svg",
  "p-id": "15892",
  width: "200",
  height: "200"
};
const _hoisted_2 = /* @__PURE__ */ createElementVNode("path", {
  d: "M1064 826.24a32 32 0 0 1 32 32v87.232a32 32 0 0 1-32 32h-597.76a32 32 0 0 1-32-32v-87.296a32 32 0 0 1 32-32h597.76z m-813.12 0a32 32 0 0 1 32 32v87.232a32 32 0 0 1-32 32H88a32 32 0 0 1-32-32v-87.296a32 32 0 0 1 32-32H250.88z m813.12-397.12a32 32 0 0 1 32 32v87.232a32 32 0 0 1-32 32h-597.76a32 32 0 0 1-32-32V461.12a32 32 0 0 1 32-32h597.76z m-813.12 0a32 32 0 0 1 32 32v87.232a32 32 0 0 1-32 32H88a32 32 0 0 1-32-32V461.12a32 32 0 0 1 32-32H250.88zM1064 32a32 32 0 0 1 32 32v87.296a32 32 0 0 1-32 32h-597.76a32 32 0 0 1-32-32V64a32 32 0 0 1 32-32h597.76zM250.88 32a32 32 0 0 1 32 32v87.296a32 32 0 0 1-32 32H88a32 32 0 0 1-32-32V64a32 32 0 0 1 32-32H250.88z",
  fill: "currentColor",
  "p-id": "15893"
}, null, -1);
const _hoisted_3 = [
  _hoisted_2
];
function _sfc_render(_ctx, _cache, $props, $setup, $data, $options) {
  return openBlock(), createElementBlock("svg", _hoisted_1, _hoisted_3);
}
var xlBiaoge = /* @__PURE__ */ _export_sfc(_sfc_main, [["render", _sfc_render]]);

export { xlBiaoge as default };
